import { defineComponent, provide, toRef } from '@vue/composition-api';
import { experimentProviderName } from './constants.js';

var script = defineComponent({
    name: 'SbExperimentProvider',
    props: {
        experimentService: {
            type: Object,
            required: true,
        },
        isLoadingExperiments: {
            type: Boolean,
            required: true,
        },
        log: {
            type: Function,
            default: undefined,
            required: true,
        },
    },
    setup: function (props) {
        provide(experimentProviderName, {
            experimentService: toRef(props, 'experimentService'),
            isLoadingExperiments: toRef(props, 'isLoadingExperiments'),
            log: props.log,
        });
    },
});

export default script;
